import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const player_portals_option = (data: PLAYER_PORTALS_MODELS.Option) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    label: elements?.name?.value,
    value: elements?.id?.value,
    fontAwesomeIcon: elements?.font_awesome_icon?.value,
  };
};

export default player_portals_option;
